// Serializador para manejar arrays anidados
export function querySerializer(params: Record<string, unknown>) {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== null && value !== undefined) {
      if (key === "pageRequest" || key === "pageable" || key === "request") {
        // Manejar el objeto recursivamente
        Object.entries(value).forEach(([subKey, subValue]) => {
          if (subValue !== null && subValue !== undefined) {
            if (subKey === "sort" && Array.isArray(subValue)) {
              // Para el array sort, unir elementos con comas
              searchParams.append(`${subKey}`, subValue.join(","));
            } else {
              searchParams.append(`${subKey}`, String(subValue));
            }
          }
        });
      } else {
        searchParams.append(key, String(value));
      }
    }
  });

  return searchParams.toString();
}
